<template>
  <div>

    <div style="padding-left: 18px;padding-right: 18px;height: 100%;">
      <div>
        <el-row :gutter="0" class="panel-group"
          style="height:  630px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="gaojing" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  告警总揽
                </div>
              </div>


            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1360px;float: left;white-space: nowrap;">
            <el-table border stripe :data="powerValue" style="font-size: 14px;">
              <template v-for="(item2, index2) in power">
                <el-table-column v-if="index2 == 0" :key="index2" :prop="item2" :label="item2" width="105"
                  align="center" fixed style="background-color: #ebeef5;">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.总计 != 0 ? 'danger' : 'success'"
                      disable-transitions>{{scope.row.告警名称}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column v-else :key=" index2" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>

          </el-col>
        </el-row>





      </div>
    </div>
  </div>
</template>

<script>
  // import layout1 from "../../layout/layout1";
  // import ECharts from "vue-echarts";
  export default {
    name: "bianyaqi",
    data () {
      return {
        projectId: 0,
        datas: {},
        power: [],
        powerValue: []
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      }
    },
    components: {
      // layout1, 
      // "v-chart": ECharts,
    },
    created () {
      this.projectId = this.$getCookie("projectId");

      this.searchPeak();
    },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      searchPeak () {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str = strs[0] + "-" + strs[1]
        this.$http
          .post("bma-distribution-service/monthReport/searchAlarm", {
            date: str,
            projectId: this.projectId,
            dateType: this.dateType
          })
          .then((res) => {
            this.datas = res.data

            this.datas.forEach((item) => {
              this.power = []
              {
                let tempArray = {}
                item.forEach((data) => {
                  this.power.push(data.day);

                  tempArray[data.day] = data.value

                })
                this.powerValue.push(tempArray)
              }
            })




          });
      },

    },
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;
    background: #fff;



    .card-panel-col {

      /* margin-bottom: 32px; */
      ~.el-table .cell {
        padding-left: 0px;
      }
    }

    .card-panel-col>.cell {

      padding-left: 0px;

    }

    .card-panel {
      height: 208px;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      border-color: rgba(0, 0, 0, .05);



      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 54px 0 0 14px;
        width: 100px;
        text-align: center;
        /* padding: 16px; */
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        /* float: left; */
        font-size: 48px;
      }

      .card-panel-description {
        float: left;
        font-weight: bold;
        margin-top: 56px;
        margin-left: 10px;
        text-align: left;
        width: 200px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-text-info {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
</style>